import { HubConnectionBuilder, LogLevel, HttpTransportType } from '@microsoft/signalr'
import config from '@/config'

const url = config.api

export default {
  install (Vue) {
    const connection = new HubConnectionBuilder()
      .withUrl(`${url.consig}/usuariosHub`, {
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets
      })
      .withAutomaticReconnect({
        nextRetryDelayInMilliseconds: retryContext => {
          if (retryContext.elapsedMilliseconds < 120000) return 5000
          else return null
        }
      })
      .configureLogging(LogLevel.None)
      .build()

    Vue.prototype.$usuariosHub = connection
  }
}



// WEBPACK FOOTER //
// ./src/service/websocket/usuariosHub.js